import Select from 'react-select';
const SearchableSelect = (props) => {
    return (
        <>
            <div className='input-box'>
                {props.label ? (
                    <label htmlFor={props.input.name} className='input-label'>
                        {props.label}
                    </label>
                ) : (
                    <></>
                )}
                <Select
                    id={props.input.name}
                    className={`${(props.meta.error || props.meta.submitError) && props.meta.touched ? 'is-invalid' : ''}`}
                    placeholder={props.placeholder}
                    options={props.options}
                    {...props.input}
                    searchable
                />

                {(props.meta.error || props.meta.submitError) && props.meta.touched && <div className='invalid-feedback'>{props.meta.error || props.meta.submitError}</div>}
            </div>
        </>
    );
};

export default SearchableSelect;
